// src/index.js
import React from "react";
import ReactDOM from "react-dom/client"; // Updated import
import "./index.css"; // Import TailwindCSS or your main CSS
import App from "./App";

const container = document.getElementById("root"); // Get the root element
const root = ReactDOM.createRoot(container); // Create a root.

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
